import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Nav from './components/Nav/Nav'
import Home from './paginas/Home/Home';
import Planos from './paginas/Planos/Planos';
import Contato from './paginas/Contato/Contato';
import Cliente from './paginas/Cliente/Cliente';
import Pagina404 from './paginas/Pagina404/Pagina404';
import Politica from './paginas/PoliticaDePrivacidade/Politica';
import Termos from './paginas/TermosDeUso/Termos';

/* Import da biblioteca AOS */
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';




function App() {
  /* Inicialização da biblioteca AOS */
  AOS.init();

  return (
    <BrowserRouter>
    <ScrollToTop/> {/* <-- coloca ele aqui dentro do Router */}
    <Nav/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/cliente" element={<Cliente />} />
        <Route path="*" element={<Pagina404 />} />
        <Route path='politicaDePrivacidade' element={<Politica/>} />
        <Route path='termosDeUso' element={<Termos/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
